module.exports = __webpack_public_path__ + "static/media/sitta.47d1fd8f.png";